/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { productDetailsNameSX } from '@/components/blocks/ProductDetails/styles/name';
import { useProductDetails } from '@/data/Content/ProductDetails';
import { useSkuListTable } from '@/data/Content/SkuListTable';
import { ContentContext } from '@/data/context/content';
import { useLocalization } from '@/data/Localization';
import { getProductDisplayInfo } from '@/utils/getProductDisplayInfo';
import { isKitOrBundleType } from '@/utils/productIsA';
import { Stack, Typography } from '@mui/material';
import { FC, useContext } from 'react';
import { srOnly } from '../Common/styles/commonStyles';

export const ProductDetailsDisplay: FC<{hidePartNumber?:boolean}> = ({hidePartNumber=false}) => {
	const { selection, product } = useContext(ContentContext) as ReturnType<
		typeof useProductDetails
	> &
		ReturnType<typeof useSkuListTable>;
	const isKitOrBundle = isKitOrBundleType[product?.type ?? 'unknown'];
	const sku = !isKitOrBundle ? selection?.sku : product;
	const { name, partNumber } = getProductDisplayInfo(sku, product);
	const localization = useLocalization('productDetail');
	const eaaMsgsNLS = useLocalization('EaaMessages');
	return (
		<Stack>
			{name ? (
				<Typography variant="h1" sx={productDetailsNameSX} className='main_header' aria-label ={name}>
					{name}
				</Typography>
			) : null}
			{!hidePartNumber && !isKitOrBundle && partNumber ? (
				<Typography variant="overline">{localization.skuLabel.t({ value: partNumber?.split('-')[0] })}</Typography>
			) : null}
		{/* 	{short ? <Typography variant="body1AsH2">{short}</Typography> : null} */}
		</Stack>
	);
};
